<template>
    <rkm-modal
        large
        ref="RkmModal"
        title="Procedimento"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <Form
                :additionals="additionals"
                :cid="cid"
                :form="form"
                :key="formKey"
                :model="model"
            />
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Mixins.
import {object} from '@/mixins'

export default {
    components: {Form},
    data: () => ({
        formKey: 0,
        index: null,
        item: null,
        model: {},
    }),
    methods: {
        open(item = null, index = null) {
            this.item = item
            this.index = index
            this.model = this.clone(item ?? this.getModelVazio())
            this.formKey++

            this.$refs.RkmModal.show()
        },
        getModelVazio() {
            return {
                procedimentoSolicitado: null,
                dataSolicitacao: null,
                clinicaId: null,
                caraterInternacaoId: null,
                profissionalSolicitanteAssistente: null,
                profissionalSolicitanteDocumentoTipoId: null,
                profissionalSolicitanteDocumentoNumero: null,
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.item) {
                        this.procedimentos.splice(this.index, 1, this.clone(this.model))
                    } else {
                        this.procedimentos.push(this.clone(this.model))
                    }

                    this.$refs.RkmModal.hide()
                })
        },
    },
    mixins: [object],
    props: {
        additionals: {type: Object, required: false},
        cid: {type: Object, required: false},
        form: {type: Object, required: false},
        procedimentos: {type: Array, required: true},
    },
}
</script>
